import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AsyncPipe, NgIf } from '@angular/common';
import { AiChatWindowComponent, AiChatWindowTitleBarComponent } from '@panaya/ai-chat/ui';
import { AiChatWindowContentComponent } from '../ai-chat-window-content';
import { AiChatConversationService } from '../conversation-tools';
import { AiChatLayoutService } from '../ai-chat-layout.service';
import { AiChatLayout } from '@panaya/ai-chat/shared';
import { CanvasFrameComponent } from '../canvas/canvas-frame/canvas-frame.component';
import { CanvasFrameStore } from '../canvas/canvas-frame.store';

/**
 * The panel render point, placed by the host in its app shell's splitter. In the sidebar layout it shows
 * the chat window; in the canvas layout it shows the chat window at a fixed width and the canvas frame beside it.
 */
@Component({
    standalone: true,
    selector: 'p-ai-chat-panel',
    imports: [AiChatWindowComponent, AiChatWindowTitleBarComponent, AiChatWindowContentComponent, CanvasFrameComponent, AsyncPipe, NgIf],
    templateUrl: './ai-chat-panel.component.html',
    styleUrls: ['./ai-chat-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AiChatPanelComponent {
    private readonly layoutService = inject(AiChatLayoutService);
    private readonly conversation = inject(AiChatConversationService);
    protected readonly layout$ = this.layoutService.layout$;
    protected readonly frameStore = inject(CanvasFrameStore);
    protected readonly isPanelOpen$ = this.layoutService.isPanelOpen$;
    protected readonly isCanvasOpen$ = this.layoutService.isCanvasOpen$;
    protected readonly assistantWorking$ = this.conversation.assistantWorking;

    protected setLayout(layout: AiChatLayout): void {
        this.layoutService.setLayout(layout);
    }
}
